import { Component, Input, OnInit, ViewChild, OnChanges } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';

import { ChartOptions } from '../../interfaces/chart-options';

@Component({
    standalone: false,
    selector: 'universal-pie-chart',
    templateUrl: './universal-pie-chart.component.html',
    styleUrls: ['./universal-pie-chart.component.scss']
})
export class UniversalPieChartComponent implements OnInit, OnChanges {
    @ViewChild('chart') chart: ChartComponent;
    @Input() ratios: number[] = [];
    @Input() properties: string[] = [];
    @Input() addNotCalcStats: boolean;

    @Input()
    colors?: string[];

    chartOptions: Partial<ChartOptions> = {};
    chartSize = 200;
    scaled = false;

    constructor() {}

    ngOnInit(): void {
        this.buildChart(this.ratios, this.properties, true);
    }

    ngOnChanges(): void {
        this.buildChart(this.ratios, this.properties, false);
    }

    buildChart(ratios: number[] = [], properties: string[] = [], animation: boolean): void {
        const safeRatios = Array.isArray(ratios) ? ratios : [];
        const safeProperties = Array.isArray(properties) ? properties : [];

        // Keep labels and series in sync; Apex pie charts can fail on inconsistent arrays.
        const normalized = safeRatios.reduce(
            (acc, ratio, index) => {
                const isValidRatio = typeof ratio === 'number' && Number.isFinite(ratio) && ratio >= 0;
                const property = safeProperties[index];
                const isValidProperty = typeof property === 'string' && property.trim().length > 0;

                if (isValidRatio && isValidProperty) {
                    acc.series.push(Number(ratio.toFixed(2)));
                    acc.labels.push(property);
                }

                return acc;
            },
            { series: [] as number[], labels: [] as string[] }
        );

        this.chartOptions = {
            series: normalized.series,
            chart: {
                height: this.chartSize,
                type: 'pie',
                animations: {
                    enabled: animation
                }
            },
            labels: normalized.labels,
            legend: {
                show: normalized.series.length > 0,
                position: 'right',
                fontSize: '12px',
                offsetX: 20
            },
            responsive: [
                {
                    breakpoint: 1300,
                    options: {
                        legend: {
                            position: 'bottom'
                        }
                    }
                }
            ],
            colors: this.colors || ['#008FFB', '#00E396', '#feb019', '#ff4560', '#775dd0']
        };
    }
}
